 "use strict";
 /**
  * trsTooltip Module
  *
  * Description
  */
 angular.module('trsTooltipModule', []).directive('trsTooltip', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

     return {
         restrict: 'EA',
         link: function(scope, iElement, iAttrs) {
             $timeout(function() {
                 iElement.tooltip({
                 	trigger:'hover'
                 });
             });
         }
     };
 }]);